export const discountTypeLabelMap = {
  coupon: "Coupon",
  salePricing: "Sale Pricing",
  loyalty: "Loyalty",
  bundle: "Bundle",
  instant: "Instant",
  rounding: "Rounding",
  "springbig-cashback": "Springbig Reward",
};

export const effectTypeLabelMap = {
  PERCENT_OFF: "Percent Off",
  DOLLAR_OFF: "Dollar Off",
  FIXED_PRICE: "Fixed Price",
  FREE: "Free",
  ROUNDING: "Rounding Adj.",
};
